import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["as"];
import React, { forwardRef } from 'react';
import { Heading as RebassHeading } from 'rebass';
var Heading = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'h1' : _ref$as,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(RebassHeading, _extends({
    ref: ref,
    as: as
  }, rest));
});
Heading.displayName = 'Heading';
export default Heading;